import axios from 'axios'
import { Message } from 'element-ui';
import router from '../router'

const apiClient = axios.create({
  // baseURL: 'https://api.example.com', // 替换为你的 API 基础 URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})
apiClient.defaults.baseURL = process.env.NODE_ENV === 'development' ? './api' : 'https://yapisdk.50pk.com'
// 获取数据示例
export const getData = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.get(endpoint, { ...data })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

// 提交数据示例
export const postData = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.post(endpoint, { ...data })
    return response.data
  } catch (error) {
    handleError(error)
  }
}
// 更新数据示例
export const updateData = async (endpoint, data = {}) => {
  try {
    const response = await apiClient.put(endpoint, { ...data })
    return response.data
  } catch (error) {
    handleError(error)
  }
}

// 删除数据示例
export const deleteData = async (endpoint) => {
  try {
    const response = await apiClient.delete(endpoint)
    return response.data
  } catch (error) {
    handleError(error)
  }
}
// 处理错误
const handleError = (error) => {
  console.error('API Error:', error)
  // 可以根据需要抛出错误或返回默认值
}
// 添加请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    // 在请求发送之前做些什么
    config.params = {
      ...config.params, // 保留原有的查询参数
      // platform: 0 // 替换为你的 platform 值
    }
    return config
  },
  (error) => {
    // 对请求错误做些什么
    Message.error({
      message: '请求超时，请检查网络后重试',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
    return Promise.reject(error)
  }
)
apiClient.interceptors.response.use(data => {
  if (data.status && data.status == 200 && data.data.status == 'error') {
    Message.error({
      message: 'data.data.msg',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
    // Vue.prototype.$loading.hide();
    return;
  }
  if (data.status && data.status == 200 && data.data.code == '-1001') {
    // refreshToken()
    // reset()
  }
  if (data.status && data.status == 200 && data.data.code == '-1002') {
    reset()
  }
  if (data.status && data.status == 204) {
    return { data: { code: 0 } }
  }
  return data
}, err => {
  if (!err.response) {
    // Vue.prototype.$loading.hide();
    Message.error({
      message: '请求超时，请检查网络后重试',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
    const config = err.config;
    config.__retryCount = config.__retryCount || 0;
    const MAX_RETRY = 3;
    if (config.__retryCount >= MAX_RETRY) {
      Message.error({
        message: '请求超时，请检查网络后重试',
        center: true, // 设置消息居中
        duration: 3000 // 消息持续时间
      }); // 显示成功消息
      return Promise.resolve(err);
    }
    config.__retryCount += 1;
    return retryRequest(config, MAX_RETRY - config.__retryCount + 1); // 调整剩余次数
  }
  if (err.response.status == 504) {
    Message.error({
      message: '服务器被吃了⊙﹏⊙∥',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
  }
  if (err.response.status == 404) {
    Message.error({
      message: '找不到资源⊙﹏⊙∥',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
  } else if (err.response.status == 403) {
    Message.error({
      message: '权限不足',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
  } else if (err.response.status == 500) {
    Message.error({
      message: '服务端错误⊙﹏⊙∥',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
  } else {
    Message.error({
      message: '未知错误',
      center: true, // 设置消息居中
      duration: 3000 // 消息持续时间
    }); // 显示成功消息
  }
  // Vue.prototype.$loading.hide();
  return Promise.resolve(err);
})
function reset() {
  window.localStorage.removeItem('access_token');
  window.localStorage.removeItem('refresh_token');
  window.localStorage.removeItem('userInfo');
  window.localStorage.removeItem('loginMes')
  if (route.path !== '/index') {
    router.push({
      path: "/index"
    })
  }
  Message.error({
    message: '授权未通过，请重新登录',
    center: true, // 设置消息居中
    duration: 3500 // 消息持续时间
  }); // 显示成功消息
}
// 创建一个重试函数
function retryRequest(config, retries = 3, delay = 1000) { // 默认总重试3次
  return new Promise((resolve, reject) => {
    const attemptRequest = (attemptsLeft) => {
      apiClient(config)
        .then(resolve)
        .catch((error) => {
          if (attemptsLeft <= 0) {
            reject(error);
          } else {
            setTimeout(() => attemptRequest(attemptsLeft - 1), delay);
          }
        });
    };
    attemptRequest(retries);
  });
}